
import './modernizr.js'; // 'npm run modernizr' to create this file


import '../node_modules/jquery-slimscroll/jquery.slimscroll.js';

